<script>
  import { getLanguage } from "i18n/language.js";

  export let url;
  export let doc;

  $: locale = $getLanguage;

  document.addEventListener("webviewerloaded", function () {
    iframe &&
      iframe.contentWindow.PDFViewerApplicationOptions.set("locale", locale);
  });

  let iframe;
</script>

<div class="wrapper">
  <iframe
    bind:this={iframe}
    title={doc.title}
    src={`/viewer/web/viewer.html?file=${encodeURIComponent(url)}`}
    width="800px"
    height="1200px"
    style="border: none;"
  />
</div>

<style>
  .wrapper {
    position: relative;
  }
  .wrapper::before {
    content: "";
    display: block;
    padding-bottom: 100vh;
  }
  .wrapper > :first-child {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
